export type {
  Template,
  TemplateInput,
  ComponentType,
  RuntimeScript,
} from "./types";
export { TemplateSchema, createTypedComponent, createTemplate } from "./types";
export { TemplateRegistry } from "./registry";
export { TemplateCapabilities } from "./capabilities";

// Permission (merged from @brains/permission-service)
export {
  PermissionService,
  UserPermissionLevelSchema,
  EntityActionSchema,
  EntityActionRequiredLevelSchema,
  entityActionPolicyRuleSchema,
  entityActionPolicyConfigSchema,
  EntityActionPermissionError,
} from "./permission-service";
export type {
  UserPermissionLevel,
  EntityAction,
  EntityActionRequiredLevel,
  EntityActionPolicyRule,
  EntityActionPolicyConfig,
  EntityActionPolicyEntry,
  EntityActionPolicy,
  PermissionConfig,
  PermissionRule,
  PermissionLookupContext,
  PermissionServiceOptions,
  WithVisibility,
} from "./permission-service";
export { matchSpaceSelector } from "./space-selector";

// Render service (merged from @brains/render-service)
export { RenderService } from "./render-service";
export type {
  ViewTemplate,
  ViewTemplateRegistry,
  WebRenderer,
  ImageRenderer,
  PdfRenderer,
  MediaRenderer,
  Renderer,
  OutputFormat,
  SiteBuilder,
  SiteBuilderOptions,
  BuildResult,
  SiteContentEntityType,
} from "./render-types";
export {
  ViewTemplateSchema,
  OutputFormatSchema,
  SiteBuilderOptionsSchema,
  BuildResultSchema,
  SiteContentEntityTypeSchema,
} from "./render-types";
